import type React from "react";
import { Card, CardLabel } from "./Card";
import { ACCENT_BLUE, ACCENT_GREEN } from "../colors";

export interface TopBarItem {
  label: string;
  value: number;
  display: string;
}

interface TopBarsProps {
  title: string;
  items: TopBarItem[];
  delay: number;
  accentTop?: string;
  accentRest?: string;
}

export function TopBars({
  title,
  items,
  delay,
  accentTop = ACCENT_GREEN,
  accentRest = ACCENT_BLUE,
}: TopBarsProps): React.JSX.Element {
  const max = items[0]?.value || 1;
  return (
    <Card delay={delay}>
      <CardLabel>{title}</CardLabel>
      <div className="space-y-3">
        {items.map((s, i) => {
          const width = (s.value / max) * 100;
          return (
            <div key={`${s.label}-${i}`}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-white/80 text-sm font-body truncate pr-3">
                  <span className="text-white/30 font-head font-semibold mr-2">{i + 1}</span>
                  {s.label}
                </span>
                <span className="font-head font-semibold text-sm text-white whitespace-nowrap">
                  {s.display}
                </span>
              </div>
              <div className="h-2 bg-white/5 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${width}%`,
                    background: i === 0 ? accentTop : accentRest,
                    animation: window.matchMedia("(prefers-reduced-motion: reduce)").matches
                      ? undefined
                      : `pmBarGrow 900ms ease-out ${delay + i * 100}ms both`,
                    transformOrigin: "left",
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
